export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14474.30354295.jpg";